module.exports = __webpack_public_path__ + "static/media/manovr-8.2dbd522c.jpg";